import React, { useState, useContext,useEffect, useRef } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import './../common.css'; // Import common CSS styles
import { groups } from "../msalConfig"; // Import group IDs


function AtsgHomePage() {
  const message1 = "Read resource";
  const message2 = "Update Resource";
  const message3 = "Create Resource";
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();
  const [responseHtml, setResponseHtml] = useState(null); // State to store the response HTML
  const [message, setMessage] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Extract the user's groups from the ID token
  const userGroups = accounts[0]?.idTokenClaims?.groups || [];
  
  console.log("user groups ATSG Home",userGroups)
  console.log(groups.XioSupportToolsAtsgRW)
  // Check if the user groups conatins read & write group
  //const isRWAuthorized = Object.values(groups.EsOps).some((groupId) => userGroups.includes(groupId));
  const isRWAuthorized = userGroups.includes(groups.XioSupportToolsAtsgRW);
  console.log("RW authorized", isRWAuthorized)

  // Check if the user groups contains read only group
  //const isROAuthorized = Object.values(groups.XioSupportToolsAtsgRO).some((groupId) => userGroups.includes(groupId));
  const isROAuthorized = userGroups.includes(groups.XioSupportToolsAtsgRO);
  console.log("RO authorized", isROAuthorized)

  const isAdminAuthorized = userGroups.includes(groups.XioSupportToolsAtsgAdmin);
  console.log("Admin authorized", isAdminAuthorized)

  function goToReadScripts() {
    navigate('/atsg/read');
  }
  function goToWriteScripts() {
    console.log("write scripts");
    navigate('/atsg/write');
    //set to true when "Create or Update Resource" button pressed
    //setIsSubmitted(true);
  }

  function goToCreateScripts() {
    navigate('/atsg/write/create_device');
  }

  console.log("atsg home")
  return (
      <>
      <div className='home-box shadow-xl rounded-sm shadow-cyan-500/30 ' >
          <div >
            
            <button
              onClick={goToReadScripts}
              className={"home-button rounded-md shadow-xl shadow-cyan-500/30 w-64"}
            >
              {message1}
            </button>
          </div>
          <div >
            <button
              onClick={goToWriteScripts}
              className={"home-button rounded-md shadow-xl shadow-cyan-500/30 w-64"}
            >
              {message2}
            </button>
          </div>
            {isAdminAuthorized && (
            <div>
              <button
                onClick={goToCreateScripts}
                className={"home-button rounded-md shadow-xl shadow-cyan-500/30 w-64"}
              >
                {message3}
              </button>
            </div>
          )}
      </div>
      {/* Render a warning banner when the create resource button is pressed and user doesn't have create resource permission*/}
     {/* { (isSubmitted && !isRWAuthorized && <UnAuthorizedWarningBanner/>)} 
      { isSubmitted && isRWAuthorized && (navigate('/atsg/write'))} */}

      </>
  );
}


function UnAuthorizedWarningBanner(props) {
  console.log("Access denied")
    return ( !props.isRWAuthorized) ? (
        <div className="surface-ground flex align-items-center justify-content-center min-w-screen overflow-hidden">
            <div className="flex flex-column align-items-center justify-content-center  w-96">
                    <div className="w-full surface-card py-8 sm:px-8 flex flex-column align-items-center" style={{ borderRadius: '2px' }}>
                        <h1 className="text-600 text-red-700 font-bold text-2xl mb-5 mt-2">Access Denied</h1>
                        <div className="text-black mb-2">Make sure you are part of the group<li>XioSupportToolsAtsgRW</li></div>
                    </div>
                </div>
            </div>
    ): ("")  
};


function UnAuthPopup({ isRWAuthorized }) {
  const newWindowRef = useRef(null); // Use a ref to track the new window

  useEffect(() => {
    if (!isRWAuthorized) {
      // Close the previous window if it exists
      if (newWindowRef.current && !newWindowRef.current.closed) {
        newWindowRef.current.close();
      }

      // Open a new browser window
      newWindowRef.current = window.open('', '_blank', 'width=800,height=600');
      //newWindowRef.current = window.open('', uniqueWindowName, 'width=800,height=600');
      if (newWindowRef.current) {
        // Write the HTML content to the new window
        newWindowRef.current.document.open();
        newWindowRef.current.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Response HTML</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  line-height: 1.6;
                  padding: 20px;
                }
              </style>
            </head>
            <body>
              <h1> Access denied </h1>
            </body>
          </html>
        `);
        newWindowRef.current.document.close();
      } else {
        alert('Unable to open a new browser window. Please check your browser settings or disable pop-up blockers.');
      }
    }

    // Cleanup function to close the window when the component unmounts
    return () => {
      if (newWindowRef.current && !newWindowRef.current.closed) {
        newWindowRef.current.close();
      }
    };
  },); // Trigger the effect whenever htmlContent changes

  return null; // This component doesn't render anything in the current window
}


export default AtsgHomePage;